import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Protected from "@/components/Protected";
import Landing from "@/pages/Landing";
import Courses from "@/pages/Courses";
import CourseDetail from "@/pages/CourseDetail";
import LessonDetail from "@/pages/LessonDetail";
import Anatomy from "@/pages/Anatomy";
import Dashboard from "@/pages/Dashboard";
import Quiz from "@/pages/Quiz";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import Pricing from "@/pages/Pricing";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PayPalReturn from "@/pages/PayPalReturn";
import Admin from "@/pages/Admin";
import Gallery from "@/pages/Gallery";
import { Toaster } from "@/components/ui/sonner";
import "@/App.css";

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/courses" element={<Courses />} />
            <Route path="/courses/:id" element={<CourseDetail />} />
            <Route path="/lessons/:id" element={<LessonDetail />} />
            <Route path="/anatomy" element={<Anatomy />} />
            <Route path="/quiz/:id" element={<Protected><Quiz /></Protected>} />
            <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/paypal/return" element={<PayPalReturn />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/admin" element={<Protected><Admin /></Protected>} />
          </Routes>
        </Layout>
        <Toaster position="top-center" />
      </BrowserRouter>
    </AuthProvider>
  );
}
